import { render, staticRenderFns } from "./RiskTypes.vue?vue&type=template&id=4ebae014&"
import script from "./RiskTypes.vue?vue&type=script&lang=ts&"
export * from "./RiskTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports